module.exports = __webpack_public_path__ + "img/form-upper-ball.639e089b.png";